import React from "react";
import { connect } from "react-redux";
import Table from "react-bootstrap/Table";
// import Spinner from 'react-bootstrap/Spinner'

const AgentsFreeIn = props => {
  const tableBody = () => {
    const ret = props.agents_available_list_in.map((agent, idx) => {
      const currentQueue =
        "active_queue" in agent ? agent.active_queue : agent.curr_queue;
      return (
        <tr key={agent.id}>
          <td>{idx + 1}</td>
          <td>{agent.name}</td>
          <td>
            {agent.status} ({agent.status_time})
          </td>
          <td>{agent.logged_in_time}</td>
          <td>{currentQueue}</td>
          <td>{agent.missed_calls}</td>
        </tr>
      );
    });

    // // Display "Loading..." Spinner initially
    // // Does not work as intended. Will display Spinner
    // // if there are no agents available
    // if (ret.length > 0) {
    //     return ret
    // } else {
    //     return (
    //         <tr>
    //             <td colSpan="6">
    //                 <Spinner animation="border">
    //                     <span className="visually-hidden">Loading...</span>
    //                 </Spinner>
    //                 Loading...
    //             </td>
    //         </tr>
    //     )
    // }
    return ret;
  };

  return (
    <Table striped bordered hover variant="dark">
      <thead>
        <tr>
          <th>#</th>
          <th>Agent</th>
          <th>Status(Duration)</th>
          <th>Logged In(Duration)</th>
          <th>Queue Name</th>
          <th>Missed Calls</th>
        </tr>
      </thead>
      <tbody>{tableBody()}</tbody>
    </Table>
  );
};

const mapStateToProps = state => {
  return {
    agents_available_list_in: state.rmqReducer.agents.agents_available_list_in,
    user: state.authReducer.user,
  };
};

export default connect(mapStateToProps, {})(AgentsFreeIn);
